import React from 'react';
import { Button } from './ui/Button';
import { FadeIn } from './ui/FadeIn';
import { useConsultation } from './ConsultationContext';
export function FinalCTA() {
  const {
    openModal
  } = useConsultation();
  return <section className="relative py-24 md:py-32 overflow-hidden bg-cream-dark" data-id="element-120">
      {/* Subtle texture overlay */}
      <div className="absolute inset-0 opacity-[0.04] mix-blend-overlay" style={{
      backgroundImage: 'url("data:image/svg+xml,%3Csvg viewBox=%220 0 200 200%22 xmlns=%22http://www.w3.org/2000/svg%22%3E%3Cfilter id=%22noiseFilter%22%3E%3CfeTurbulence type=%22fractalNoise%22 baseFrequency=%220.65%22 numOctaves=%223%22 stitchTiles=%22stitch%22/%3E%3C/filter%3E%3Crect width=%22100%25%22 height=%22100%25%22 filter=%22url(%23noiseFilter)%22/%3E%3C/svg%3E")'
    }} data-id="element-121"></div>

      <div className="container relative z-10 mx-auto px-4 md:px-6 text-center" data-id="element-122">
        <div className="max-w-3xl mx-auto" data-id="element-123">
          <FadeIn data-id="element-124">
            <h2 className="text-4xl md:text-5xl lg:text-6xl font-serif text-primary mb-10 leading-tight" data-id="element-125">
              Your skin is thirsty.
              <br data-id="element-126" />
              <span className="italic" data-id="element-127">
                Let's give it exactly what it needs.
              </span>
            </h2>
          </FadeIn>

          <FadeIn delay={200} data-id="element-128">
            <Button className="md:w-auto w-full text-sm md:text-base px-12 mb-6" onClick={openModal} data-id="element-129">
              Book My Free Consultation
            </Button>
          </FadeIn>

          <FadeIn delay={400} data-id="element-130">
            <p className="text-jade font-medium text-sm md:text-base tracking-wide" data-id="element-131">
              No commitment. No pressure. Just a conversation.
            </p>
          </FadeIn>
        </div>
      </div>
    </section>;
}